<lns-modal
  *ngIf="modalContent.content"
  [modalContent]="modalContent"
  (closeModal)="closeModal()"
></lns-modal>
